import { defineMessages } from 'react-intl';
export default defineMessages({
    title: {
        id: 'providerIntro.title',
        defaultMessage: 'Connect {provider}'
    },
    step1: {
        id: 'providerIntro.step1',
        defaultMessage: 'Sign in to your SmartMixin account (NOT your {provider} login).'
    },
    step3KeyOrToken: {
        id: 'providerIntro.step3KeyOrToken',
        defaultMessage: 'Paste it here.'
    },
    step3Wunderground: {
        id: 'providerIntro.step3Wunderground',
        defaultMessage: 'Paste your API key, then pick a nearby station or enter any station ID.'
    },
    step3EmailPassword: {
        id: 'providerIntro.step3EmailPassword',
        defaultMessage: 'Enter them here.'
    },
    step3OAuth: {
        id: 'providerIntro.step3OAuth',
        defaultMessage: 'Authorize SmartMixin in the popup.'
    },
    getStarted: {
        id: 'providerIntro.getStarted',
        defaultMessage: 'Get started'
    },
    signupBanner: {
        id: 'providerIntro.signupBanner',
        defaultMessage: 'Almost there — create your free SmartMixin account to connect {provider}.'
    },
    // Per-provider step 2 ("Get your credentials") copy.
    wundergroundStep2: {
        id: 'providerIntro.wundergroundStep2',
        defaultMessage: "Get your Weather Underground API key. You'll then be able to connect any station — yours or a public one."
    },
    ecowittStep2: {
        id: 'providerIntro.ecowittStep2',
        defaultMessage: 'Get your Ecowitt API key and Application key.'
    },
    ambientWeatherStep2: {
        id: 'providerIntro.ambientWeatherStep2',
        defaultMessage: 'Get your Ambient Weather API key.'
    },
    davisStep2: {
        id: 'providerIntro.davisStep2',
        defaultMessage: 'Get your Davis V2 API key and API secret.'
    },
    weatherflowStep2: {
        id: 'providerIntro.weatherflowStep2',
        defaultMessage: 'Get your Tempest personal-use token.'
    },
    myAcuriteStep2: {
        id: 'providerIntro.myAcuriteStep2',
        defaultMessage: 'Use your existing My AcuRite account email and password.'
    },
    netatmoWeatherStep2: {
        id: 'providerIntro.netatmoWeatherStep2',
        defaultMessage: 'Sign in to Netatmo when prompted — no API key needed.'
    },
    netatmoEnergyStep2: {
        id: 'providerIntro.netatmoEnergyStep2',
        defaultMessage: 'Sign in to Netatmo when prompted — no API key needed.'
    },
    // Wunderground wizard — step B copy.
    wundergroundFindNearby: {
        id: 'providerIntro.wundergroundFindNearby',
        defaultMessage: 'Find stations near me'
    },
    wundergroundOrEnterId: {
        id: 'providerIntro.wundergroundOrEnterId',
        defaultMessage: 'Or enter a station ID'
    },
    wundergroundBrowsePublic: {
        id: 'providerIntro.wundergroundBrowsePublic',
        defaultMessage: "Don't have a station? Browse public ones"
    }
});
